/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/prefer-ternary */

export const objectToFormdata = (payload: any, form: any = null, namespace: any = null): FormData => {
  const formatData: FormData = form || new FormData()
  let formKey: string | null = null

  Object.keys(payload).forEach((key: string) => {
    if (namespace) {
      formKey = `${namespace}[${key}]`
    } else {
      formKey = key
    }
    if (typeof payload[`${key}`] === 'object' && !(payload[`${key}`] instanceof File)) {
      objectToFormdata(payload[`${key}`], formatData, key)
    } else {
      formatData.append(formKey, payload[`${key}`])
    }
  })

  return formatData
}
